import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import { ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'NotVerifiedModal',
  props: {
    isOpen: {
      type: Boolean,
    },
    message: {
      type: String,
      default: "",
    },
  },
  emits: ["close", "resend"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const showButton = ref(true);

  function close() {
    emits("close");
  }
  function resend() {
    emits("resend");
    showButton.value = false;
  }

const __returned__ = { emits, props, showButton, close, resend, Modal, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})